import React, { useEffect, useMemo, useRef } from "react";

const ORBS = [
  { size: 280, color: "rgba(201,169,110,0.45)", left: "8%", top: "12%", dur: 22 },
  { size: 220, color: "rgba(244,213,213,0.55)", left: "70%", top: "8%", dur: 28 },
  { size: 320, color: "rgba(93,126,79,0.28)", left: "78%", top: "62%", dur: 32 },
  { size: 180, color: "rgba(201,169,110,0.55)", left: "18%", top: "70%", dur: 24 },
  { size: 240, color: "rgba(244,213,213,0.4)", left: "45%", top: "40%", dur: 30 },
  { size: 160, color: "rgba(201,169,110,0.5)", left: "50%", top: "82%", dur: 26 },
  { size: 200, color: "rgba(93,126,79,0.22)", left: "30%", top: "30%", dur: 36 },
];

export default function Particles({ className = "" }) {
  const wrap = useRef(null);

  const orbs = useMemo(() => ORBS, []);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const nodes = wrap.current?.querySelectorAll(".orb") || [];
    let raf;
    let t = 0;
    const animate = () => {
      t += 0.004;
      nodes.forEach((n, i) => {
        const k = i + 1;
        const dx = Math.sin(t * (0.6 + i * 0.1)) * 40 * k * 0.4;
        const dy = Math.cos(t * (0.5 + i * 0.12)) * 30 * k * 0.4;
        n.style.transform = `translate3d(${dx}px, ${dy}px, 0)`;
      });
      raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div ref={wrap} aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
      {orbs.map((o, i) => (
        <span
          key={i}
          className="orb"
          style={{ width: o.size, height: o.size, background: o.color, left: o.left, top: o.top }}
        />
      ))}
    </div>
  );
}
